// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DotLoading_wrapper__35sv5","dot1":"DotLoading_dot1__2nU1v","jump1":"DotLoading_jump1__ks_jN","dot2":"DotLoading_dot2__1XXge","dot3":"DotLoading_dot3__1hFmL"};